export { default } from './Swatches.js';
